import React from 'react';
import Box from '@material-ui/core/Box';

import WithPaper from 'common/hocs/WithPaper';
import TypographyWrapper from './TypographyWrapper';

const puddings = { lg: 15, md: 5, sm: 8, };

type Props = {
    message: string | undefined,
};

const BookstoreClosed: React.FC<Props> = ({ message, }) => {
    return (
        <Box textAlign="center"
             p={puddings}>
            <TypographyWrapper>
                {message}
            </TypographyWrapper>
        </Box>
    );
};

export default WithPaper(null)(BookstoreClosed);
